import { useTranslation } from 'next-i18next'
// Dependencies.
import styled from 'styled-components'

import { colors } from '../utils'
import { H4 } from './H4'
import { User } from '../types'
import { H5 } from './H5'

// Div.
const Div = styled.div`
  width: 300px;
  height: 80px;
  display: flex;
  margin-top: 30px;

  .imageContainer {
    min-width: 80px;
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 100%;
    background-color: ${colors.grey};

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .profileContainer {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    justify-content: center;
    align-items: flex-start;

    & > h4 {
      margin: 0;
    }
  }

  .going {
    color: ${colors.grey};
  }

  .host {
    color: ${colors.purple};
  }

  .editHost {
    color: ${colors.grey};
  }

  .editGoing {
    color: ${colors.red};
    cursor: pointer;
  }
`

// Props.
interface Props extends User {
  isHost: boolean
  isEditable: boolean
  onRemove?: (id: number) => void
  isInside24hrs: boolean
  isFreeEvent: boolean
}

// Participant Profile.
export const ParticipantProfile: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')
  // Props.
  const {
    full_name,
    nickname,
    image,
    isHost,
    isEditable,
    id,
    isInside24hrs,
    isFreeEvent,
  } = props

  const onRemoveClicked = (event: React.MouseEvent<HTMLHeadingElement>) => {
    // TODO: Need API to remove user from my event
    props.onRemove(id)
  }
  if (isHost) return null
  // ..
  return (
    <Div>
      {/* Image. */}
      <div className="imageContainer">
        {image && (
          <img
            src={image}
            alt={t(
              `ParticipantProfile2092045491`,
              `participant display picture`,
            )}
          />
        )}
      </div>

      {/* Profile. */}
      <div className="profileContainer">
        <H4>{nickname || full_name}</H4>
        {isEditable && (isFreeEvent || (!isFreeEvent && !isInside24hrs)) ? (
          <H5
            className={`${(isHost && 'editHost') || 'editGoing'}`}
            onClick={(isHost && null) || onRemoveClicked}>
            {(isHost && 'You') || 'Remove'}
          </H5>
        ) : (
          <H5 className={`going ${(isHost && 'host') || ''}`}>
            {t(`Going`, `Going`)}
            {isHost && ' (Host)'}
          </H5>
        )}
      </div>
    </Div>
  )
}
